import React from 'react';
import SlidingCounter from "./sliding_counter";
import PropTypes from 'prop-types';
import { tryToAbbreviate, QUANTITY } from '../../selectors/string_selectors';

class PurchaseLimitItem extends React.Component {
  //getters
  getDecimalPlaces() {
    return this.props.limitAmountUnit === QUANTITY ? 0 : this.props.decimalPlaces;
  }

  getCurrentTotal() {
    return Number(this.props.total);
  }

  getLimit() {
    return Number(this.props.limit);
  }

  //render
  render() {
    return (
      <div className="purchase-limit-item">
        <div className="label">
          {this.props.name}
        </div>
        <SlidingCounter
          units={tryToAbbreviate(this.props.limitAmountUnit)}
          limit={this.getLimit()}
          currentTotal={this.getCurrentTotal()}
          decimalPlaces={this.getDecimalPlaces()}
        />
      </div>
    );
  }

}

PurchaseLimitItem.propTypes = {
  name: PropTypes.string.isRequired,
  limitAmountUnit: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  decimalPlaces: PropTypes.number.isRequired,
};


export default PurchaseLimitItem;



// WEBPACK FOOTER //
// ./src/components/purchase_limits/purchase_limit_item.jsx